import { translate } from '@vimeo/i18n-runtime';

let navigator: any;

const isIOS = navigator ? /iphone|ipod|ipad/i.test(navigator.userAgent.toLowerCase()) : false;
const isAndroid = navigator ? /android/i.test(navigator.userAgent.toLowerCase()) : false;
const isMac = navigator ? /mac/i.test(navigator.userAgent.toLowerCase()) : false;

// generate macOS app link
const getMacOSLink = () => {
  const defaults = {
    label: translate({
      singular: 'Vimeo for {MACOS}',
      replacements: {
        MACOS: 'macOS',
      },
    }),
    href: 'https://apps.apple.com/app/apple-store/id1356686763?pt=417731&ct=lohp&mt=8',
  };

  if (isIOS || isAndroid) {
    return null;
  } else if (isMac) {
    return Object.assign({}, defaults, {
      href: 'macappstore://apple.com/app/apple-store/id1356686763?pt=417731&ct=LOHP&mt=8',
    });
  } else {
    return defaults;
  }
};

// generate iOS app link
const getIOSLink = () => {
  const defaults = {
    label: translate({
      singular: 'Vimeo for {IOS}',
      replacements: {
        IOS: 'iOS',
      },
    }),
    href: 'https://apps.apple.com/app/apple-store/id425194759?pt=417731&ct=enterprise_mobile_comms_LP&mt=8',
  };

  return isAndroid ? null : defaults;
};

// generate Android app link
const getAndroidLink = () => {
  const defaults = {
    label: translate({
      singular: 'Vimeo for {ANDROID}',
      replacements: {
        ANDROID: 'Android',
      },
    }),
    href: 'https://play.google.com/store/apps/details?id=com.vimeo.android.videoapp&hl=en_US&gl=US&pli=1',
  };

  return isIOS ? null : defaults;
};

// generate iOS app link
const getCreationIOSLink = () => {
  const defaults = {
    label: translate({
      singular: 'Vimeo Create for {IOS}',
      replacements: {
        IOS: 'iOS',
      },
    }),
    href: 'https://apps.apple.com/us/app/vimeo/id425194759',
  };

  return isAndroid ? null : defaults;
};

// generate Android app link
const getCreationAndroidLink = () => {
  const defaults = {
    label: translate({
      singular: 'Vimeo Create for {ANDROID}',
      replacements: {
        ANDROID: 'Android',
      },
    }),
    href: 'https://play.google.com/store/apps/details?id=com.vimeo.android.videoapp',
  };

  return isIOS ? null : defaults;
};

// standard link to Magisto product
const magistoLink = () => {
  return {
    label: 'Magisto',
    href: 'https://www.magisto.com/',
  };
};

// standard link to vimeo for Shopify
const vimeoForShopifyLink = () => {
  return {
    label: translate({
      singular: 'Vimeo for {SHOPIFY}',
      replacements: {
        SHOPIFY: 'Shopify',
      },
    }),
    href: 'https://apps.shopify.com/vimeo_product_video_maker',
  };
};

// standard link to vimeo for Zoom
const vimeoForZoomLink = () => {
  return {
    label: translate({
      singular: 'Vimeo for {ZOOM}',
      replacements: {
        ZOOM: 'Zoom',
      },
    }),
    href: '/integrations/zoom',
    fa: {
      type: 'click',
      component: 'apps',
      container: 'footer',
      keyword: 'vimeo_for_zoom',
    },
  };
};

// assemble custom array of app links
const assembleLinks = () => {
  return [
    getMacOSLink(),
    getIOSLink(),
    getAndroidLink(),
    getCreationIOSLink(),
    getCreationAndroidLink(),
    magistoLink(),
    vimeoForShopifyLink(),
    vimeoForZoomLink(),
  ];
};

export default assembleLinks;
